import { bizmatesApi, bizmatesWordbookApi } from '@/utils/bizmatesApi';
import qs from 'qs';
import { getApiMethod } from '@/modules/apiSelector'

export default {
  namespaced: true,
  state() {
    return {
      categoryLists: null,
      categorizedWords: [],
      menuItemPerPage: 50,
      modalItemPerPage: 50,
      modalCategorizedWords: null,
      modalCategoryId: 0,
      listCategoryId: 0,
      selectAll: false,
      selectedWords: [],
      isIndeterminate: false,
      enabledDragStyle: true,
      wordsForDeletion: null,
      wordsMovedToCategory: null,
      categoryCreatedId: 0,
      categoryUpdatedId: 0,
      categoryDeleted: null,
      categorySorted: false,
      categoryWordsDeleted: null,
      isTranslationListEdit: false,
      translationListEdited: {
        isCancel: false,
      },
      translatedWord: null,
      translation: null,
    };
  },
  mutations: {
    setCategoryLists(state, payload) {
      state.categoryLists = payload;
    },
    setCategorizedWords(state, payload) {
      state.categorizedWords = payload;
    },
    setModalCategorizedWords(state, payload) {
      state.modalCategorizedWords = payload;
    },
    setModalCategoryId(state, payload) {
      state.modalCategoryId = payload;
    },
    setSelectedWords(state, payload) {
      state.selectedWords = payload;
    },
    setIsIndeterminate(state, payload) {
      state.isIndeterminate = payload;
    },
    setSelectAll(state, payload) {
      state.selectAll = payload;
    },
    setEnabledDragStyle(state, payload) {
      state.enabledDragStyle = payload;
    },
    setCategoryCreated(state, payload) {
      state.categoryCreatedId = payload;
    },
    setCategoryUpdated(state, payload) {
      state.categoryUpdatedId = payload;
    },
    setCategoryDeleted(state, payload) {
      state.categoryDeleted = payload;
    },
    setWordsForDeletion(state, payload) {
      state.wordsForDeletion = payload;
    },
    setListCategoryId(state, payload) {
      state.listCategoryId = payload;
    },
    setMenuItemPerPage(state, payload) {
      state.menuItemPerPage = payload;
    },
    setModalItemPerPage(state, payload) {
      state.modalItemPerPage = payload;
    },
    setCategorySorted(state, payload) {
      state.categorySorted = payload;
    },
    setCategoryWordsDeleted(state, payload) {
      const data = { items: payload, affected_rows_words: payload.length - 1 };
      state.categoryWordsDeleted = data;
    },
    setIsTranslationListEdit(state, payload) {
      state.isTranslationListEdit = payload;
    },
    setTranslationListEdited(state, payload) {
      state.translationListEdited = payload;
    },
    setWordsMovedToCategory(state, payload) {
      state.wordsMovedToCategory = payload;
    },
    setTranslatedWord(state, payload) {
      state.translatedWord = payload;
    },
    setTranslation(state, payload) {
      state.translation = payload;
    },
    setAppStar(state, payload) {
      let word = state.categorizedWords?.hits.find((item) => item.id === payload.id);
      if (word) {
        word.is_important = payload.important;
      }
    },
    setWordNote(state, payload) {
      let word = state.categorizedWords?.hits.find((item) => item.id === payload.id);
      if (word) {
        word.notes = payload.note;
      }
    }
  },
  actions: {
    async getCategoryLists({ commit }) {
      await bizmatesApi.get('vocabulary/category_list', {}, response => {
        if (response.data !== undefined && Object.keys(response.data).length > 0) {
          commit('setCategoryLists', response.data);
        }
      });
    },
    async getMenuCategorizedWords({ commit }, params) {
      const apiMethod = getApiMethod('getCategorizedWords');
      await apiMethod(params, (data) => {
        commit('setCategorizedWords', data);
      });
    },
    async createCategoryName({ commit }, params) {
      await bizmatesApi.post('vocabulary/insert_category', qs.stringify(params), {}, response => {
        commit('setCategoryCreated', response.data.data.id);
      });
    },
    async updateCategoryName({ commit }, params) {
      await bizmatesApi.post('vocabulary/update_category', qs.stringify(params), {}, response => {
        commit('setCategoryUpdated', response.data.data.affected_rows);
      });
    },
    async deleteWordsByCategory({ commit }, params) {
      await bizmatesApi.delete('vocabulary/category', params, response => {
        commit('setCategoryDeleted', response.data.data);
      });
    },
    async updateSortCategory({ commit }, params) {
      await bizmatesApi.post('vocabulary/sort_category', params, {}, response => {
        commit('setCategorySorted', response.data.status);
      });
    },
    async moveWordsToCategory({ commit }, params) {
      await bizmatesApi.put('vocabulary/move_words', params, {}, response => {
        commit('setWordsMovedToCategory', { ...response.data, ...params });
      });
    },
    async updateTranslationList({ commit }, params) {
      await bizmatesApi.post('vocabulary/update', params, {}, response => {
        commit('setTranslationListEdited', { ...response.data, isCancel: false });
      });
    },
    async translateWord({ commit }, params) {
      const apiMethod = getApiMethod('getTranslation');
      commit('setTranslatedWord', await apiMethod(
        params.word, 
        params.lesson_id, 
        params.program_id
      ));
    },
    async saveTranslation({ commit }, params) {
      const apiMethod = getApiMethod('storeVocabulary');
      const response = await apiMethod(
        params.word,
        params.lesson_id,
        params.program_id
      );
      commit('setTranslation', { ...params, id: response.result });
    },
    async setAsImportant(context, params) {
      await bizmatesWordbookApi.post('word/important', qs.stringify(params), err => err);
    },
    resetSelectedWords({ commit }) {
      commit('setSelectedWords', []);
      commit('setIsIndeterminate', false);
      commit('setSelectAll', false);
    },
  },
};
